/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      TeleClaimStatuses: '$MHF_ModelNameVal_$MHF|TeleClaimStatuses',

};
